import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ServiceResponse } from 'src/app/models/service-response';
import { ProfilService } from 'src/app/rest_services/profil.service';
import { UserService } from 'src/app/rest_services/user.service';


@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit, OnDestroy {

  usersLoading:boolean=true;
  historyLoading:boolean=true;
  usersSubscription!: Subscription;
  users: Array<any> = [];
  history: any[] = [];
  currentProfile: string = '';
  affectedProfilForm !: FormGroup;
  constructor( private userService: UserService,
    private profileService: ProfilService,
    private fb : FormBuilder){}
  ngOnInit(): void {
    this.getCompanyUsers();
    this.getCompanyProfiles();
    this.affectedProfilForm =this.fb.group({
      selectedProfile: ['', Validators.required],
    })
    setTimeout(()=>{
      this.loadScript("../assets/plugins/table/datatable/datatables.js");
    }, 200);
  }
  public loadScript(scripts:string) {
    let node = document.createElement("script");
    node.src = scripts;
    node.type = "text/javascript";
    node.async = true;
    var scriptsTags = document.getElementsByTagName('script');
    for (var i = scriptsTags.length; i--;) {
        if (scriptsTags[i].src != scripts) {
          document.getElementsByTagName("body")[0].appendChild(node);
        }else {
          break;
        }
    }
  }

  formatAction(action: string): string {
    const startKeyword = 'a affecté le profil ';
    const endKeyword = " à l'utilisateur";
  
    const startIndex = action.indexOf(startKeyword) + startKeyword.length;
    const endIndex = action.indexOf(endKeyword);
  
    if (startIndex !== -1 && endIndex !== -1) {
      const profileName = action.substring(startIndex, endIndex);
      return `Le profil <strong>${profileName}</strong> est affecté à cet utilisateur`;
    }
  
    return action; // Return the original action if the format doesn't match
  }  
  

  userSelected:any;
  selectedUser(member :any){
    this.userSelected = member;
    this.currentProfile = member.profile;
    this.affectedProfilForm.get('selectedProfile')?.setValue(this.userSelected.profile)
  }
  isProfileUnchanged(): boolean {
    const selectedProfile = this.affectedProfilForm.get('selectedProfile')?.value;
    return selectedProfile === this.currentProfile;
  }

  
  profiles:any[]=[];
  profilesSubscription!: Subscription;

  profilesLoading:boolean=true;

  getCompanyProfiles() {
    this.profilesSubscription = this.profileService.getCompanyProfiles().subscribe(
      (resp:ServiceResponse) => {
        if (resp.code == "04af68f47a2a3038ddc63abc533719d1") {
          this.profiles = resp.profiles;
        }
        this.profilesLoading = false;
      },
      (err:any) => {
        console.log(err);
        this.profilesLoading = false;
      }
    );
  }
  forWhat:any='/affectHistory'
  getHistory() {
    this.historyLoading=true;
    this.profilesSubscription = this.profileService.getHistory(this.userSelected.uuid, this.forWhat).subscribe(
      (resp:any) => {
        if (resp.code == "70105b5c5ff9e3f8fafdf2ea024a3c95") {
          this.history = resp.history;

          this.history.sort((a, b) => {
            const dateA = new Date(a.date).getTime();
            const dateB = new Date(b.date).getTime();
            return dateA - dateB;
          });

          setTimeout(()=>{
            (<any>$("#alter_paginations")).DataTable( {
              "pagingType": "full_numbers",
              "language": {
                "sProcessing": "Traitement en cours ...",
                "sLengthMenu": "Afficher _MENU_ lignes",
                "sZeroRecords": "Aucun résultat trouvé",
                "sEmptyTable": "Aucune donnée disponible",
                "sInfo": "",
                "sInfoEmpty": "",
                searchPlaceholder: "Saisir un mot clé",
                "sInfoFiltered": "",
                "sInfoPostFix": "",
                "sSearch": "Chercher:",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Chargement...",
                "oPaginate": {
                  "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                },
                "oAria": {
                  "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                }
              },
              "order": [
                [0, "desc"]
            ],
              drawCallback: function () {
                (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
              }
          });
        }, 200);
        }
        this.historyLoading=false;
      },
      (err:any) => {
        console.log(err);
        this.historyLoading=false;
      }
    );
  }

  addError:string='';
  loadingAffectation:boolean=false;
  profilToUser() {
    this.loadingAffectation = true;
    const profileUuid = this.affectedProfilForm.get('selectedProfile')?.value;
    const userUuid = this.userSelected.uuid;
    this.profileService.affectProfile(profileUuid, userUuid).subscribe(
        (response: any) => {
            this.loadingAffectation = false;
            $("html, body").animate({scrollTop:0})
            if (response.code === '5e6bd8d5e4ae0de7e8a3a38ba03be46f') {
              // Update the user's profile in the 'users' array
              const updatedUserIndex = this.users.findIndex(user => user.uuid === userUuid);
              if (updatedUserIndex !== -1) {
                this.users[updatedUserIndex].profile = profileUuid; // Update the profile value
              }
              $("#profile_affected").show();
              $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              });
              setTimeout(()=>{
                $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                });
                $("#profile_affected").hide();
              }, 2000);
            } else if (response.code === 'd0c6dff928606bb4803e5de058a88f0c') {
              this.addError = 'L\'utilisateur n\'a pas les droits pour affecter le profil';
                $("#profile_not_affected").show();
                $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){});
                setTimeout(()=>{
                  $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){});
                  $("#profile_not_affected").hide();
                }, 8000)
            } else if (response.code === '701d38e95c5f472f3e3be4384c454076') {
              this.addError = 'Le profil spécifié n\'a pas été trouvé'; 
              $("#profile_not_affected").show();
              $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){});
              setTimeout(()=>{
                $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){});
                $("#profile_not_affected").hide();
              }, 8000)
            } else if (response.code === '0e5c44e9b9bc846fb5d66c8f57be0f4d') {
              this.addError = 'L\'utilisateur spécifié n\'a pas été trouvé'; 
              $("#profile_not_affected").show();
              $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){});
              setTimeout(()=>{
                $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){});
                $("#profile_not_affected").hide();
              }, 8000)
            } else {
              this.addError = 'Une erreur s\'est produite';
              $("#profile_not_affected").show();
              $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){});
              setTimeout(()=>{
                $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){});
                $("#profile_not_affected").hide();
              }, 8000)
            }

            // Reset the form and hide the modal
            this.affectedProfilForm.reset();
            (<any>$('#profilesModal')).modal('hide');
        },
        (error) => {
          this.loadingAffectation = false;
          this.addError = 'Une erreur s\'est produite';
          this.loadingAffectation = false;
          $("#profile_not_affected").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){});
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){});
            $("#profile_not_affected").hide();
          }, 8000)
          this.affectedProfilForm.reset();
          (<any>$('#profilesModal')).modal('hide');
        }
    );
  }


  getCompanyUsers() {
    this.usersSubscription = this.userService.getCompanyUsers().subscribe(
      (resp: ServiceResponse) => {
        if (resp.code == "7c6a49bd6f8a0089318c6aec421f2756") {
          this.users = resp.users;
          setTimeout(()=>{
            (<any>$("#alter_pagination")).DataTable( {
              "pagingType": "full_numbers",
              "language": {
                "sProcessing": "Traitement en cours ...",
                "sLengthMenu": "Afficher _MENU_ lignes",
                "sZeroRecords": "Aucun résultat trouvé",
                "sEmptyTable": "Aucune donnée disponible",
                "sInfo": "",
                "sInfoEmpty": "Aucune ligne affichée",
                "sInfoFiltered": "(Filtrer un maximum de_MAX_)",
                "sInfoPostFix": "",
                "sSearch": "Chercher:",
                searchPlaceholder: "Saisir un mot clé",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Chargement...",
                "oPaginate": {
                  "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                },
                "oAria": {
                  "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                }
              },
              drawCallback: function () {
                (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
              }
          });
        }, 200);

        }
        this.usersLoading= false;
      },
      (err: any) => {
        console.log(err);
        this.usersLoading = false;
        
      }
    );
  }

  getProfileName(user: any) {
    if (user.profile === "a21aab19-d73e-47db-a61c-d2c1f0c8a251") {
      return "Commercial";
    } else if (user.profile === "d8aeff31-284b-11ed-8482-00163ee67c31") {
      return "Assistante commerciale";
    } else if (user.profile === "981dc265-63b8-45ba-b356-befb5a9a6f74") {
      return "Directeur";
    } else {
      const profil = this.profiles.find((prf)=> prf.uuid == user.profile)
      if(profil)return profil.name.replaceAll("_"," ");
    }
  }

  ngOnDestroy(): void {
    this.usersSubscription?.unsubscribe();
  }

}